export const PHONE_BREAKPOINT_PX = 768;

export function isPhoneViewport(): boolean {
  if (typeof window === 'undefined') return false;

  const narrowViewport = window.innerWidth < PHONE_BREAKPOINT_PX;
  const shortTouchLandscape = window.matchMedia?.(
    '(pointer: coarse) and (orientation: landscape) and (max-height: 520px)'
  ).matches;

  return narrowViewport || Boolean(shortTouchLandscape);
}
